const t = "quantitySelector_sYRYd", e = "quantitySelector__increase_2zlO2", _ = "quantitySelector__decrease_aNYsv", a = "quantitySelector__display_lLQjz", c = "quantitySelector__quantity_XOs3s", n = "quantitySelector__divider_xjVRs", r = "quantitySelector__max_cadDg", i = "quantitySelector__labelWrapper_nBPOZ", l = {
  quantitySelector: t,
  quantitySelector__increase: e,
  quantitySelector__decrease: _,
  quantitySelector__display: a,
  quantitySelector__quantity: c,
  quantitySelector__divider: n,
  quantitySelector__max: r,
  quantitySelector__labelWrapper: i
};
export {
  l as default,
  t as quantitySelector,
  _ as quantitySelector__decrease,
  a as quantitySelector__display,
  n as quantitySelector__divider,
  e as quantitySelector__increase,
  i as quantitySelector__labelWrapper,
  r as quantitySelector__max,
  c as quantitySelector__quantity
};
//# sourceMappingURL=quantitySelector.module.scss.js.map
